<template>
  <div class="problem-summary-box">
    <div class="problem-summary-box-content">
      <!--左边的文章菜单栏-->
      <div class="left-box">
        <p class="title">{{ $t('key1000740') }}</p>
        <div class="problem-list" v-for="item in documentData">
          <p class="sub-title" @click="item.show = !item.show">
            <span class="text">{{ item.name }}</span>
            <Icon :class="{rotate:item.show}" type="ios-arrow-down icon"/>
          </p>
          <ul class="problem-list" v-if="item.show">
            <li v-for="sub in item.children">
              <p class="sub-title" @click="sub.show = !sub.show">
                <span class="text second-menu" :title="sub.name">{{ sub.name }}</span>
                <Icon :class="{rotate:sub.show}" type="ios-arrow-down icon"/>
              </p>
              <ul v-if="sub.show && sub.helpDocsList">
                <li v-for="article in sub.helpDocsList" class="sub-title article"
                  :class="{active: activeId === article.id}">
                  <span class="three-menu" :data-id="article.id" :title="article.title" @click="setArticle(article)">{{ article.title }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!--文章内容-->
      <div class="right-box">
        <div class="right-nav" v-if="breadMenu && breadMenu.length > 0">
          <span v-for="(item,index) in breadMenu">
            <span class="p-tit" :class="{'c-tit' : index === breadMenu.length -1}">{{ item }}</span>
            <span class="separate" v-if="index !== breadMenu.length -1">/</span>
          </span>
        </div>
        <p class="content-title">{{ contentTitle }}</p>
        <div class="right-content" @click="setEnlargeImg" ref="scrollContainer" v-html="content"></div>
      </div>
      <!--右侧的锚点导航-->
      <anchorNavigation ref="anchorNav" setTop="48px" :headerHeight="0"></anchorNavigation>
    </div>
    <div v-if="modal1" class="big-img-modal">
      <div class="img-content" @mousewheel="mousewheelHandel">
        <div class="head" ref="imgHead">
          <div>{{ $t('key1003059') }}</div>
          <div class="head-r" ref="headR">
            <a class="icon iconfont mr5" :title="$t('key1003057')" :href="enlargeImgUrl" target="_blank">&#xe692;</a>
            <i class="icon iconfont mr5" :title="$t('key1003058')" @click="resetImg">&#xe912;</i>
            <i class="icon iconfont i-close" :title="$t('key1000248')" @click="closeImgModal">&#xe747;</i>
          </div>
        </div>
        <div class="img-box" draggable="true" ref="draggable">
          <div :style="imgStyle" style="display: inline-block">
            <img style="" :src="enlargeImgUrl"/>
          </div>
        </div>
      </div>
    </div>
    <!--返回顶部-->
    <AppBackTop :bottom="60"></AppBackTop>
  </div>
</template>

<script>
import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import Draggabilly from 'draggabilly';
import anchorNavigation from "@/components/common/anchorNavigation";
import AppBackTop from "@/components/common/AppBackTop.vue";

export default {
  name: "previewHelpCenter",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      documentData: [],
      activeId: null,
      breadMenu: [],
      content: '',
      contentTitle: '',
      modal1: false,
      scale: 1,
      translateX: 0,
      translateY: 0,
      drag: false,
      client: {
        x: 0,
        y: 0
      },
      offset: {
        x: 0,
        y: 0
      },
      offsetY: 0,
      enlargeImgUrl: '',
      helpDoscList: [],
      language: null
    };
  },
  computed: {
    imgStyle() {
      return {
        transform: `scale(${this.scale}) translate(0px, 0px) rotate(0deg)`
      };
    },
  },
  created() {
    let queryId = this.$route.query.id;
    let type = this.$route.query.type;
    this.language = this.$route.query.language;
    if (type === 'edit') {
      this.getDetils(queryId).then(() => {
        if (queryId) {
          this.$nextTick(() => {
            this.activeId = Number(queryId);
            this.helpDoscList.forEach(i => {
              if (i.id === Number(queryId)) {
                this.setArticle(i);
              }
            });
          });
        }
      });
    } else {
      let previewContent = localStorage.getItem('previewContent');
      if (previewContent) {
        this.activeId = Number(queryId);
        let obj = JSON.parse(previewContent);
        this.getDetils(queryId).then(() => {
          if (queryId) {
            this.handleData(queryId, obj);
          }
        });
      }
    }
  },
  methods: {
    // 处理数据
    handleData(queryId, obj) {
      let v = this;
      if (v.documentData.length > 0) {
        function treeToList(tree, result = [], level = 0) {
          tree.forEach(node => {
            result.push(node);
            node.children && treeToList(node.children, result);
          });
          return result;
        }

        let list = treeToList(v.documentData);
        let breadMenuList = [];
        if (list.length > 0) {
          let newList = JSON.parse(JSON.stringify(list));
          newList.map((item) => {
            let categoryInternational = item.categoryInternational || [];
            if (categoryInternational.length > 0) {
              categoryInternational.map((ele) => {
                if (ele.language === v.language) {
                  breadMenuList.push(ele.name);
                }
              });
            } else {
              breadMenuList.push(item.name);
            }
          });
          v.breadMenu = v.uniqueFunc(breadMenuList);
          list.map((item) => {
            if (item.id === Number(queryId)) {
              item.helpDocsList.push({
                title: obj.title,
                id: v.activeId
              });
            }
          });
        }
      }
      v.setAddArticle();
      v.$forceUpdate();
    },
    // 获取所有目录
    getDetils(queryId) {
      let v = this;

      function recursion(originData) {
        let obj = {};
        let p = 0;
        v.helpDoscList = [];
        originData.forEach(i => {
          let name = '';
          let categoryInternational = i.categoryInternational || [];
          if (categoryInternational.length > 0) {
            categoryInternational.map((item) => {
              if (item.language === v.language) {
                name = item.name;
              }
            });
          } else {
            name = i.name;
          }
          i.name = name;
          i.children = [];
          i.show = true;
          i.fullName = [i.name];
          obj[i.id] = i;
          if (obj[i.pId]) {
            i.fullName.push(...obj[i.pId].fullName);
            let helpDocsList = i.helpDocsList || [];
            if (helpDocsList.length > 0) {
              helpDocsList = helpDocsList.filter(i => i.showStatus && !i.isDeleted);
              helpDocsList.forEach(d => {
                d.fullName = i.fullName;
                let helpDocInternationalList = d.helpDocInternationalList || [];
                if (helpDocInternationalList.length > 0) {
                  helpDocInternationalList.map((ele) => {
                    if (ele.language === v.language) {
                      d.title = ele.title;
                      d.content = ele.content;
                    }
                  });
                }
              });
              v.helpDoscList.push(...helpDocsList);
            }
            obj[i.pId].children.push(i);
          }
          if (i.pId === 1) {
            p = i.id;
          }
        });
        return obj[p].children;
      }

      return new Promise(resolve => {
        v.axios.post(api.get_ymsHelpCategory_shopping_buildCategoryTree).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            let pIdList = [];
            if (data.length > 0) {
              function findNodeById(treeData, id) {
                let result = null;

                function traverse(nodes, path) {
                  for (let node of nodes) {
                    // 判断当前节点是否匹配
                    if (node.id == id) {
                      result = {node, path};
                      return;
                    }

                    // 递归遍历子节点
                    if (node.helpDocsList && node.helpDocsList.length > 0) {
                      traverse(node.helpDocsList, [...path, node]);
                    }
                  }
                }

                traverse(treeData, []);

                return result;
              }

              function getHierarchyData(treeData, id) {
                const result = findNodeById(treeData, id);

                if (result) {
                  const {node, path} = result;
                  const hierarchyData = path.map(node => ({...node}));
                  hierarchyData.push({...node});
                  return hierarchyData;
                } else {
                  return null;
                }
              }

              pIdList = data.filter((item) => {
                return item.pId === 1;
              });
              let list = getHierarchyData(data, queryId);
              if (list.length > 0) {
                let newList = list.filter((item) => {
                  return item.helpDocsList && item.helpDocsList.length > 0;
                });
                if (newList.length > 0) {
                  let arr = [];
                  let arr1 = [];
                  let helpDocsList = [];
                  newList.map((item) => {
                    helpDocsList = item.helpDocsList.filter((talg) => {
                      return talg.id == queryId;
                    });
                    let obj = JSON.parse(JSON.stringify(item));
                    obj.helpDocsList = helpDocsList;
                    arr1.push(obj);
                    data.map((ele) => {
                      if (item.pId === ele.id) {
                        arr.push(ele);
                      }
                    });
                  });
                  pIdList = [...pIdList, ...arr, ...arr1];
                  v.documentData = recursion(pIdList, 1);
                }
              }
              resolve();
            }
          }
        });
      });
    },
    // 选择文章
    setArticle(article) {
      let v = this;
      v.activeId = article.id;
      /* this.content = article.content;
       this.contentTitle = article.title;*/
      let previewContent = localStorage.getItem('previewContent');
      if (previewContent) {
        let obj = JSON.parse(previewContent);
        v.content = obj.content;
        v.contentTitle = obj.title;
        v.$nextTick(() => {
          const content = v.$el.querySelector('.right-content');
          let dom = v.$refs['scrollContainer'];
          v.$refs['anchorNav'].getAnchorsFromContent(dom, content);
        });
      }
      v.breadMenu = article.fullName.slice(0, -1).reverse();
      v.scrollTopFun();
    },
    // 状态是新增的情况下选择文章
    setAddArticle() {
      let previewContent = localStorage.getItem('previewContent');
      if (previewContent) {
        let obj = JSON.parse(previewContent);
        this.content = obj.content;
        this.contentTitle = obj.title;
        this.scrollTopFun();
      }
    },
    closeImgModal() {
      this.modal1 = false;
      document.getElementById('app').style.overflow = 'auto';
    },
    mousewheelHandel(e) {
      e.stopPropagation();
      e.preventDefault();
      if (e.wheelDelta > 0) {
        if (this.scale >= 3) return;
        this.scale = this.scale + 0.5;
      } else if (e.wheelDelta < 0) {
        if (this.scale <= 0.5) return;
        this.scale = this.scale - 0.5;
      }
    },
    setEnlargeImg(e) {
      let v = this;
      if (e.target.nodeName === 'IMG') {
        v.enlargeImgUrl = e.target.currentSrc;
        v.modal1 = true;
        document.getElementById('app').style.overflow = 'hidden';
        v.$nextTick(() => {
          let draggie = new Draggabilly(this.$refs['draggable'], {
            //containment: true,
            axis: 'xy'
          });
          v.resetImg();
          setTimeout(() => {
            if (v.$refs.imgHead.scrollWidth < document.body.clientWidth) {
              v.$refs.headR.style.position = 'absolute';
              v.$refs.headR.style.top = '0';
            } else {
              v.$refs.headR.style.position = 'fixed';
              v.$refs.headR.style.top = '50px';
            }
          }, 100);
        });
      }
    },
    resetImg() {
      this.scale = 1;
      this.$refs.draggable.style.left = 0;
      this.$refs.draggable.style.top = 0;
    }
  },
  watch: {
    '$route'() {
      let queryId = this.$route.query.id;
      let type = this.$route.query.type;
      if (type === 'edit') {
        if (queryId) {
          this.$nextTick(() => {
            this.activeId = Number(queryId);
            this.helpDoscList.forEach(i => {
              if (i.id === Number(queryId)) {
                this.setArticle(i);
              }
            });
          });
        }
      }
    }
  },
  components: {
    anchorNavigation,
    AppBackTop
  }
};
</script>

<style>
.right-content img {
  max-width: 100%;
}

.right-content p span {
  word-wrap: break-word;
  word-break: break-all;
  text-wrap: initial !important;
}
</style>
<style scoped lang="less">
@import "src/assets/styles/shopping/common";

.img-content {
  width: 1200px;
  margin: 50px auto 0 auto;
  background-color: #ffffff;
  display: inline-block;
  overflow: hidden;
}

.img-content .head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  padding: 0px 18px;
  border-bottom: 1px solid #ddd;
  position: relative;
  background-color: #ffffff;
  z-index: 1;
}

.head-r {
  position: fixed;
  right: 18px;
  top: 50px;
  height: 48px;

}

.head-r .icon {
  font-size: 18px;
  margin-right: 5px;
  cursor: pointer;
  color: #666666;
}

.head-r .icon:hover {
  opacity: 0.9;
  color: #666666;
}

.head-r .i-close:hover {
  color: red;
}

.help-search-head-box {
  border-bottom: 1px solid #D7D7D7;
  position: sticky;
  top: 0px;
  background: #fff;
  z-index: 10;
}

.help-search-head {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  height: 64px;
  font-size: 16px;

  .logo {
    display: flex;
    align-items: center;
    width: 344px;
    cursor: pointer;

    .line {
      content: '';
      width: 1px;
      height: 14px;
      background-color: #aaaaaa;
      display: block;
      margin: 0 16px;
    }

    .text {
      font-size: 18px;
      color: #333333;
    }
  }

  .search-ipt {
    width: 560px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .search-input {
      width: 490px;
      height: 34px;
      border: 2px solid #FF5310;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
      text-indent: 5px;
      font-size: 12px;
    }

    .search-btn {
      font-size: 14px;
      width: 72px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      font-weight: 400;
      color: #FFFFFF;
      background-color: @subject_color;
      border: none;
      outline: none;
      cursor: pointer;
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }

    .search-ipt-close {
      position: absolute;
      right: 78px;
      top: 24px;
      cursor: pointer;
    }

    .search-ipt-close:hover {
      opacity: 0.9;
    }
  }

  .help-tabs {
    width: 344px;
    display: flex;
    justify-content: flex-end;

    .line {
      display: none;
      width: 100%;
      height: 2px;
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: #FF5310;
      transition: 0.3s ease-out all;
    }

    .active {
      position: relative;

      .line {
        display: inline-block;
      }
    }

    .item {
      padding: 0 20px;
      height: 100%;
      line-height: 64px;
      cursor: pointer;
    }

    .item:hover, .active {
      color: @subject_color;
    }
  }
}

.help-content-box {
  background-color: #f2f2f2;
  padding: 25px 32px 5px 32px;

  .more {
    float: right;
    color: #000000;
    cursor: pointer;
    font-size: 13px;
    font-weight: initial;
    line-height: 27px;
  }

  .help-content {
    width: 1200px;
    margin: 0 auto 25px auto;
    padding: 24px 32px 0 32px;
    background-color: #ffffff;

    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #000000;
      font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    }

    .tit {
      font-family: 'Arial Normal', 'Arial', sans-serif;
      font-size: 16px;
      color: #000000;
      margin-bottom: 5px;
    }

    .col-item {
      margin-bottom: 24px;
      vertical-align: top;

      img {
        vertical-align: top;
        margin-right: 10px;
      }

      .z-box {
        display: inline-block;
        width: 210px;
      }
    }

    .item {
      font-size: 12px;
      color: #555555;
      margin-bottom: 5px;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .item:hover {
      color: @subject_color;
    }
  }

  .self-content {
    margin-bottom: 20px;

    .pointer {
      cursor: pointer;
    }

    .pointer:hover {
      opacity: 0.9;
    }
  }
}

.problem-summary-box {
  background-color: #F2F2F2;
  padding-bottom: 60px;;

  .problem-summary-box-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;

    .left-box {
      width: 230px;
      background-color: #ffffff;

      .title {
        padding: 0 24px;
        height: 46px;
        line-height: 46px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        text-align: left;
      }

      .problem-list {
        line-height: 46px;
        color: #333333;
        font-size: 14px;

        .sub-title {
          height: 46px;
          padding: 0 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .text {
            text-align: left;
          }

          .icon {
            text-align: right;
            transition: 0.2s ease-in transform;
          }

          .rotate {
            transform: rotate(180deg);
          }
        }

        .active {
          color: #FF5310;
          background-color: #FFF5F1;
        }

        .sub-title:hover {
          color: #FF5310;
          background-color: #FFF5F1;
        }

        .item-box {
          .item {
            padding-left: 48px;
            height: 46px;
            cursor: pointer;
          }

          .item:hover, .active {
            color: #FF5310;
            background-color: #FFF5F1;
          }
        }
      }
    }

    .right-box {
      width: 960px;
      background-color: #ffffff;

      .right-nav {
        height: 48px;
        line-height: 48px;
        background-color: #F2F2F2;

        .separate {
          padding: 0 5px;
        }

        .p-tit {
          color: #00000072;
        }

        .c-tit {
          color: #000000;
        }
      }

      .right-content {
        padding: 24px;
        overflow: hidden;
      }

      .content-title {
        font-size: 16px;
        color: #000;
        font-weight: bold;
        padding: 24px 24px 0 24px;
      }
    }
  }
}

.flex {
  display: flex;
}

.second-menu {
  padding-left: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.three-menu {
  padding-left: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.article {
  cursor: pointer;
}

.search-result-box {
  background-color: #F2F2F2;
  padding-bottom: 20px;
}

.search-result {
  width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 35px 40px 10px 40px;
  margin-bottom: 20px;

  .search-text {
    color: #FF5310;
  }

  .search-list {
    .search-list-item {
      padding: 15px 0;
      color: #000;
      font-size: 14px;
      cursor: pointer;
    }

    .search-list-item:hover {
      color: #FF5310;
    }
  }
}

.enlarge-box {
  text-align: center;

  img {
    max-width: 100%;
  }
}

.big-img-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  text-align: center;
  overflow: auto;

  .img-box {
    cursor: move;

    img {
      border: 1px solid #e3e5e8;
    }
  }

  a {

  }
}

.video-content {
  .video-box {
    display: flex;
    justify-content: space-between;

    .m-col-item {
      width: 260px;
      height: 150px;
      background-position: center center;
      background-size: contain;
      padding: 25px 0 0 28px;
      cursor: pointer;

      .play {
        display: block;
        width: 30px;
      }

      .play-h {
        display: none;
        transition: all 0.3s ease;
      }

      .title {
        font-size: 18px;
        color: #000;
        font-weight: initial;
        margin-bottom: 0px;
      }

      .desc {
        font-size: 24px;
        color: #000;
        font-weight: bold;
        margin-bottom: 15px;
      }

      &:hover {
        .play {
          display: none;
        }

        .play-h {
          display: block;
          transform: rotate(1.1);
          width: 30px;
        }
      }
    }

    .bottom-desc {
      width: 260px;
      text-align: center;
      margin: 15px 0 26px 0;
      color: #555555;
      font-size: 14px;
    }

    .video-item-0 {
      background-image: url("../../../../assets/images/help/b1.png");
    }

    .video-item-1 {
      background-image: url("../../../../assets/images/help/b2.png");
    }

    .video-item-2 {
      background-image: url("../../../../assets/images/help/b3.png");
    }

    .video-item-3 {
      background-image: url("../../../../assets/images/help/b4.png");
    }
  }
}

</style>
